/**
 * Notes left about one venue — the read half. Writing goes through
 * `addNote`/`setNoteDone` in `db.ts` directly (both already take an
 * optional `venueId`); this file only reads them back for the venue admin
 * screens to show under the venue they are about.
 *
 * No imports beyond the Supabase client, so it is safe for `admin/` to
 * import directly, for the same reason `sourcing.ts` and `venueSourcing.ts`
 * are.
 */
import { supabase } from './supabase'

export interface VenueNote {
  id: string
  body: string
  kind: string
  created_at: string
  done_at: string | null
  resolution: string | null
}

export async function fetchVenueNotes(venueId: string): Promise<VenueNote[]> {
  const r = await supabase
    .from('app_notes')
    .select('id,body,kind,created_at,done_at,resolution')
    .eq('venue_id', venueId)
    .order('created_at', { ascending: false })
  if (r.error) throw new Error(r.error.message)
  return (r.data ?? []) as VenueNote[]
}
